import { AssetAmount } from "@sundaeswap/asset";
import { useMemo } from "react";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { useTasteTestContext } from "../../pages/TasteTestDetail/context";
import { useCurrentTasteTestContribution } from "./useCurrentTasteTestContribution";
import { useTasteTestWithdrawOrderFees } from "./useTasteTestWithdrawOrderFees";

export const useTasteTestWithdrawAmounts = () => {
  const {
    state: { tasteTest },
  } = useTasteTestContext();
  const { totalFee } = useTasteTestWithdrawOrderFees();
  const currentContribution = useCurrentTasteTestContribution();

  const memoizedRefundableDeposit = useMemo(() => {
    if (tasteTest?.parameters?.minUTXO) {
      return new AssetAmount(tasteTest.parameters.minUTXO, ADA_METADATA);
    }
    return new AssetAmount(0n, ADA_METADATA);
  }, [tasteTest?.parameters?.minUTXO]);

  const memoizedFoldFee = useMemo(() => {
    if (tasteTest?.parameters?.foldFee) {
      return new AssetAmount(tasteTest.parameters.foldFee, ADA_METADATA);
    }
    return new AssetAmount(0n, ADA_METADATA);
  }, [tasteTest?.parameters?.foldFee]);

  const total = useMemo(
    () =>
      currentContribution
        ?.add(memoizedRefundableDeposit)
        ?.add(memoizedFoldFee)
        ?.subtract(totalFee) ?? new AssetAmount(0n, ADA_METADATA),
    [currentContribution, memoizedRefundableDeposit, totalFee]
  );

  return {
    total,
    refundableDeposit: memoizedRefundableDeposit,
    foldFee: memoizedFoldFee,
  };
};
